
import React from 'react';
import Modal from '@mui/material/Modal';
import {Box, Button, createTheme, ThemeProvider} from "@mui/material";

import GroupsIcon from '@mui/icons-material/Groups';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

import "./SetupModal.css";

export default function SetupModal(props) {

    const theme = createTheme({
        palette: {
            primary: {
                main: "#0000b7"
            },
            secondary: {
                main: "#AAAAAA"
            },
        },
    });

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4
    };

    const callback = props.callback ? props.callback : () => { console.warn("No callback specified"); };

    return (
        <React.Fragment>
            <Modal
                open={props.open}
            >
                <div className={"setupmodal-color"}>
                <ThemeProvider theme={theme}>
                    <Box sx={style}>
                        <div className={"setupmodal-header"}>
                            First Time User
                        </div>
                        <div style={{maxWidth: "90%", textAlign: "center", margin: "auto"}}>
                            <hr style={{textAlign: "center"}}/>
                        </div>
                        <div className={"setupmodal-explanation"}>
                            In order to utilize the EBIDTA Quickbooks Plugin, you must first configure your expense fields.
                        </div>
                        <div className={"setupmodal-icons"}>
                            <span><GroupsIcon color={"secondary"} className={"setupmodal-icon"}/></span>
                            <span><SyncAltIcon className={"setupmodal-icon-small"}/></span>
                            <span><AccountBalanceIcon color={"secondary"} className={"setupmodal-icon"}/></span>
                        </div>
                        <div className={"setupmodal-explanation"}>
                           Click the "Setup" button below to seperate payroll expenses from standard expenses.
                        </div>
                        <div className={"setupmodal-button"}>
                            <Button onClick={callback} variant={"outlined"}><span style={{fontWeight: "bold", minWidth: "100px"}}>Setup</span></Button>
                        </div>
                    </Box>
                </ThemeProvider>
                </div>
            </Modal>
        </React.Fragment>
    )
}